module.exports = __webpack_public_path__ + "static/media/icon-report-sidebar-login.71ad79cc.svg";